import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import ChatPage from './components/Chat/ChatPage';
import LandingPage from './components/LandingPage/LandingPage';
import { ChatProvider } from './contexts/ChatContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { UserProvider } from './contexts/UserContext';
import AuthLoader from './components/Auth/AuthLoader';
import AuthorizedRoute from './components/Auth/AuthorizedRoute';
import { FEATURE_FLAGS } from './config/featureFlags';
import VersionChecker from './utils/versionChecker';
// KBC QUIZ IMPORTS (Temporary - Event Only)
import KBCQuizApp from './components/KBCQuiz/KBCQuizApp';
// END KBC QUIZ IMPORTS

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route 
        path="/chat" 
        element={
          <AuthorizedRoute>
            <ChatPage />
          </AuthorizedRoute>
        } 
      />
      {/* KBC QUIZ ROUTE (Temporary - Event Only) */}
      <Route 
        path="/kbc-quiz" 
        element={
          <AuthorizedRoute>
            <KBCQuizApp />
          </AuthorizedRoute>
        } 
      />
      {/* END KBC QUIZ ROUTE */}
    </Routes>
  );
}

function App() {
  // Start version checking when app mounts
  useEffect(() => {
    VersionChecker.startVersionCheck();
    
    return () => {
      VersionChecker.stopVersionCheck();
    };
  }, []);

  return (
    <ThemeProvider>
      <UserProvider>
        <ChatProvider>
          <Router>
            <div className="App">
              {FEATURE_FLAGS.REQUIRE_AUTHENTICATION ? (
                <AuthLoader>
                  <AppRoutes />
                </AuthLoader>
              ) : (
                <AppRoutes />
              )}
            </div>
          </Router>
        </ChatProvider>
      </UserProvider>
    </ThemeProvider>
  );
}

export default App;
